import axios from "axios";

// TODO: point this at your actual shared base URL constant/config if one exists
// elsewhere in the app (matching the `url` used in your other API calls).
const url = process.env.REACT_APP_SERVER_URL;

function extractError(error) {
    return error?.response?.data?.msg || error?.response?.data?.error || error.message;
}

export const getReservations = async (filters = {}) => {
    const params = new URLSearchParams(
        Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined && v !== ""))
    );
    try {
        const response = await axios.get(`${url}/reservations?${params}`);
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const getAvailableRooms = async (checkin, checkout) => {
    const params = new URLSearchParams({ checkin, checkout });
    try {
        const response = await axios.get(`${url}/reservations/available-rooms?${params}`);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const createReservation = async (payload) => {
    try {
        const response = await axios.post(`${url}/reservations`, payload);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const assignRoom = async (id, roomId) => {
    try {
        const response = await axios.post(`${url}/reservations/${id}/assign-room`, { roomId });
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const checkInReservation = async (id, payload) => {
    try {
        const response = await axios.post(`${url}/reservations/${id}/check-in`, payload);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const cancelReservation = async (id, payload) => {
    try {
        const response = await axios.post(`${url}/reservations/${id}/cancel`, payload);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};

export const markNoShow = async (id, payload) => {
    try {
        const response = await axios.post(`${url}/reservations/${id}/no-show`, payload);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(extractError(error));
    }
};